<template>
  <server-list
    :request-func="roleList"
    search-placeholder="Пошук за назвою або описом ролі...">
    <template #action-button>
      <v-btn @click="openRoleDialog('create')">
        <v-icon class="mr-1">mdi-plus</v-icon>
        <span>Створити роль</span>
      </v-btn>
    </template>
    <template #items="{ items }">
      <v-data-table
        :headers="roleListHeaders"
        :hide-default-header="!items.length"
        :items="items as Role[]"
        :items-per-page="-1"
        hide-default-footer
        @dblclick:row="
          (e: any, row: any) =>
            $router.push({ name: 'role-single', params: { id: row.item.id } })
        ">
        <template #item.name="{ item }">
          <router-link :to="{ name: 'role-single', params: { id: item.id } }">
            {{ item.name }}
          </router-link>
        </template>
        <template #item.description="{ item }">
          {{ dataScopeLabel(item.data_scope) }}
        </template>
        <template #item.actions="{ item }">
          <b-action-menu
            :actions="[
              {
                title: 'Права доступу',
                action: () => {
                  $router.push({
                    name: 'role-single',
                    params: { id: item.id },
                  })
                },
                icon: 'mdi-shield-key',
                iconProps: {
                  color: 'blue-darken-3',
                },
              },
              {
                title: 'Редагувати',
                action: () => openRoleDialog('update', item),
                icon: 'mdi-pencil',
                iconProps: {
                  color: 'blue-darken-3',
                },
              },
              {
                title: 'Видалити',
                action: () => deleteRole(item),
                icon: 'mdi-delete-forever',
                disabled: item.is_system,
                listItemProps: {
                  class: 'text-error',
                },
                iconProps: {
                  color: 'error',
                },
              },
            ]"></b-action-menu>
        </template>
      </v-data-table>
    </template>
  </server-list>
</template>

<script lang="ts">
import { openDialog } from '@/dialog'
import { BActionMenu } from 'best-modules/components'
import { roleDelete, roleList } from '@/requests/role'
import { roleListHeaders } from '@/utils/tableHeaders'
import { confirm } from 'best-modules/plugins'
import ServerList from '@/components/ServerList.vue'
import { DataScope, Role } from '@/utils/types/role'

type RoleDialogAction = 'create' | 'update'

const DATA_SCOPE_LABELS: Record<Exclude<DataScope, null>, string> = {
  AUTHOR_ONLY: 'Тільки автор',
  PARTICIPATING: 'Свої (участь)',
  PARTICIPATING_AND_DEPARTMENT: 'Свої + департамент',
  ALL: 'Усі в системі',
}

export default {
  name: 'RoleList',
  components: { ServerList, BActionMenu },
  data() {
    return {
      roleListHeaders,
    }
  },
  methods: { roleList },
  setup() {
    const dataScopeLabel = (scope: DataScope) =>
      scope ? DATA_SCOPE_LABELS[scope] : '---'

    const openRoleDialog = (
      action: RoleDialogAction,
      role: Role | null = null
    ) => {
      openDialog({
        name: 'Role',
        action,
        params: {
          title: action === 'update' ? 'Редагування ролі' : 'Створення ролі',
          submitLabel: action === 'update' ? 'Зберегти' : 'Створити',
        },
        dialogData: {
          roleData: role || {},
        },
      })
    }

    const deleteRole = (role: Role) => {
      if (!role.is_system) {
        return confirm({
          text: 'Ви впевнені, що хочете видалити цю роль?',
        }).then(() => {
          return roleDelete(role.id)
        })
      }
    }

    return { openRoleDialog, deleteRole, dataScopeLabel }
  },
}
</script>
